import React, { useEffect, useState } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-phone-input-2/lib/bootstrap.css';
import styles from './organization.module.css';
import { AddClient, ClientTable, Header, SideBar } from '../../components';

export const Organization: React.FC = () => {
  const [pageKey, setPageKey] = useState(0);
  const handleModalClose = () => {
    setPageKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    localStorage.removeItem('selectedColumn');
    localStorage.removeItem('sortDirection');
  }, []);
  return (
    <div className={styles.appContainer}>
      <SideBar />
      <div className={styles.mainContent}>
        <Header />
        <AddClient onClose={handleModalClose} />
        <ClientTable key={pageKey} />
      </div>
    </div>
  );
};
